import { useEffect, useRef, useState } from 'react';
import { FaCircle } from 'react-icons/fa6';
import { IoBarcodeOutline, IoReload, IoSearch } from 'react-icons/io5';
import { LuTextCursorInput } from 'react-icons/lu';
import { MdOutlineQrCode2 } from 'react-icons/md';

import { Button } from '@hubmaster/ui';
import useDoubleClick from 'use-double-click';

interface ButtonProps {
	loading: boolean;
	activeScanner: boolean;
	iconOnly?: boolean;
	type?: 'barcode' | 'qrcode';
	onClick?: (mode: 'popup' | 'scanner') => void;
	mode?: 'popup' | 'scanner';
	className?: string;
}

export function ButtonScanner({
	activeScanner,
	loading,
	iconOnly,
	type = 'barcode',
	onClick,
	className,
	mode: modeDefault = 'scanner',
}: ButtonProps) {
	const [mode, setMode] = useState<'popup' | 'scanner'>(modeDefault);
	const buttonRef = useRef(null);

	useDoubleClick({
		onSingleClick: () => {
			onClick && onClick(mode);
		},
		onDoubleClick: () => {
			if (type === 'qrcode') return;
			if (mode === 'popup') {
				setMode('scanner');
			} else {
				setMode('popup');
			}
		},

		ref: buttonRef,
		latency: 250,
	});

	function TextStandby() {
		switch (mode) {
			case 'popup':
				return 'Aguardando...';
			default:
				return 'Abrindo scanner...';
		}
	}

	function Text() {
		if (type === 'barcode') {
			switch (mode) {
				case 'popup':
					return 'Digitar código';
				case 'scanner':
					return 'Escanear';
			}
		} else {
			return 'QR Code';
		}
	}

	function Icon() {
		if (type === 'barcode') {
			switch (mode) {
				case 'popup':
					return iconOnly ? (
						<IoSearch size={20} />
					) : (
						<LuTextCursorInput size={20} />
					);
				case 'scanner':
					return <IoBarcodeOutline size={20} />;
			}
		} else {
			return <MdOutlineQrCode2 size={20} />;
		}
	}

	useEffect(() => {
		setMode(modeDefault);
	}, [modeDefault]);

	return (
		<Button
			className={`${className}`}
			disabled={loading || activeScanner}
			size={iconOnly ? 'icon' : 'default'}
			ref={buttonRef}
		>
			{loading ? (
				<>
					<IoReload className="animate-spin" fontSize={24} />
					{!iconOnly && 'Buscando'}
				</>
			) : activeScanner ? (
				<>
					<FaCircle className="animate-pulse" fontSize={16} />
					{!iconOnly && TextStandby()}
				</>
			) : (
				<>
					<Icon />
					{!iconOnly && Text()}
				</>
			)}
		</Button>
	);
}
